import { render } from "./products.vue?vue&type=template&id=10514f7d&scoped=true&ts=true"
import script from "./products.vue?vue&type=script&lang=ts"
export * from "./products.vue?vue&type=script&lang=ts"

import "./products.vue?vue&type=style&index=0&id=10514f7d&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10514f7d"]])

export default __exports__